import { createSlice } from '@reduxjs/toolkit';


export const headerSlice = createSlice({
    name: 'header',
    initialState: {
        title: 'Dashboard'
    },
    reducers: {
        changeHeader: (state, action) => {
            state.title = action.payload;
        }
    }
})

export const { changeHeader } = headerSlice.actions;


export default headerSlice.reducer;